import { Button } from "@heroui/react";
import { Link } from "react-router-dom";
import { StatusMessage } from "./StatusMessage";

export const HashAlreadyUsed = () => (
  <>
    <StatusMessage>You have already used this link to reset your password.</StatusMessage>
    <Button
      as={Link}
      to="/login"
      size={"lg"}
      color={"secondary"}
      fullWidth={true}
    >
      Go to login
    </Button>
  </>
);
